import type { Step } from "../types/step";

export const stepIs =
	<T extends Step["name"]>(stepName: T) =>
	(step: Step): step is Extract<Step, { name: T }> =>
		step.name === stepName;
